import React from 'react';

import {
  TableContainer,
  Table,
  TableRow,
  TableBody,
  TableCell,
  Section,
  Link,
} from '@gogame/components';

const PartnerAudience = ({ data, onOpenPartnerAudience }) => {
  return (
    <Section title={'Partner Audience (1)'} isCollapsable={true}>
      <TableContainer>
        <Table width={'100%'}>
          <TableBody>
            <TableRow>
              <TableCell>
                <Link
                  onClick={(e) =>
                    onOpenPartnerAudience(e, data?.partnerAudience)
                  }
                >
                  {data?.partnerAudience?.name}
                </Link>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Section>
  );
};

export default PartnerAudience;
